import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { noop } from 'lodash';
import socialNetworkNames from '../../../../constants/social-networks';
import { buildImageUrl } from '../utils';
import { buildUrl } from '../../../../../common/utils/url/build-url';
import { openPopup } from '../../../../../common/utils/open-popup';
import Tooltip from '../../../../ui-components/tooltip/tooltip';
import InlineIcon from '../../../../ui-components/inline-icon/inline-icon';
import parentStyles from '../styles.scss';
import TumblrIcon from '../../../../../icons/compiled/components/TumblrIcon';
class Tumblr extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", () => {
      const {
        siteUrl
      } = this.props.instanceInfo;
      const {
        descriptionText,
        canShareContent,
        content
      } = this.props;
      if (canShareContent) {
        const url = buildUrl('https://www.tumblr.com/widgets/share/tool', {
          posttype: 'photo',
          // todo: need to find a way to resize image for tumblr
          content: buildImageUrl(content.coverUrl),
          caption: descriptionText.replace('{siteUrl}', siteUrl).replace('{title}', content.title),
          url: siteUrl
        });
        openPopup(url);
      }
      this.props.onShare(socialNetworkNames.TUMBLR);
    });
  }
  render() {
    const {
      className,
      dataHook,
      ariaLabel,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.onClick,
      "data-hook": dataHook,
      className: className,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(TumblrIcon, null),
      className: parentStyles.icon
    })));
  }
}
_defineProperty(Tumblr, "defaultProps", {
  onShare: noop
});
export default Tumblr;
//# sourceMappingURL=tumblr.js.map